import { useState, useRef, useEffect, useCallback } from "react";
import { useDebounce } from "./index";

interface IProps {
  cb?: (size: any) => void;
  useLoad?: boolean;
}

const useClientLayout = (props?: IProps) => {
  const { cb, useLoad } = props ?? {};
  const targetRef = useRef<any>();

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const getTargetSize = () => {
    const targetNode = targetRef.current;
    if (targetNode) {
      const { clientWidth, clientHeight } = targetNode;
      setWidth(clientWidth);
      setHeight(clientHeight);
      cb?.({ width: clientWidth, height: clientHeight });
    }
  };

  const handleImageLoad = () => {
    getTargetSize();
  };

  const handleWindowResize = useDebounce(() => {
    getTargetSize();
  }, 500);

  useEffect(() => {
    if (!useLoad) {
      getTargetSize();
    }
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [useLoad]);

  return { targetRef, onLoad: handleImageLoad, width, height };
};

export default useClientLayout;
